/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'iconEdit': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" class="st0" d="M1 13.3h14v2H1z"/><path pid="1" transform="rotate(-45.001 11.89 2.866)" class="st0" d="M10.9.9h2v4h-2z"/><path pid="2" class="st0" d="M11.9 5.7L9.1 2.9 3.4 8.5v2.9h2.8z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/views/icons/iconEdit.js